import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createSportEventDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/Sports/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.eventPostedDateTime = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackEvent = db.doc(`/Sports/${uniqueId}`);
    await getBackEvent.get().then(result => {
        console.info('result',result?.exists)
        if(result?.exists) {
            return true;
        } else {
            return false
        }
    });
}

export const getSportEventDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Sports').where("userId","==", userId).get()
    return snapshot.docs.map(doc => doc.data());
}

export const getSportEventDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Sports').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => doc.data());
}

export const getSportEventDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let event = null;
    let retailer = null;
    const eventSnapshot = await db.collection('Sports').where("uniqueId", "==", uniqueId).get()
    eventSnapshot.docs.map(doc => {
        event = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("userId", "==", event.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        event: event,
        retailer: retailer
    }
}

export const getAllSportEventDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Sports').get()
    return snapshot.docs.map(doc => doc.data());
}

export const updateSportEventDocument = async (event) => {
    const docRef = db.doc(`/Sports/${event.uniqueId}`);
    return docRef.update(event);
}

export const getAllApplicantCvs = async (employerId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('AppliedSports').where("employerId", "==", employerId).get()
    return snapshot.docs.map(doc => doc.data());
}



export const uploadSportEventImageInBase64 = (eventId, file, progress) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const filePath = `events/${eventId}/${"image-" + Date.now()}`;
        const fileRef = storage.ref().child(filePath);

        // upload task        
        const uploadTask = fileRef.putString(file, 'base64', {contentType:'image/jpeg'});
        uploadTask.on('state_changed', (snapshot) => progress(snapshot), (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}